import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import ChatBox from '../../components/ChatBox';


export default function MensagensPage() {

  return (
    <div className="p-pt-0">
      <MenuMain >
        <ChatBox />
      </MenuMain>
      <AppFooter />
    </div>
  );
}